import { StoreOptionInterface, StoreStepInterface } from '@hb/modules/global';

import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';

@Injectable()
export abstract class AbstractStoreInjectOption<Q extends number> implements StoreOptionInterface<Q>, OnDestroy {
    protected abstract readonly store: StoreStepInterface;
    protected abstract readonly lastQuestion: Q;
    protected readonly subscription = new Subscription();

    readonly activeQuestionSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    isSummary = false;
    hasCoApplicant = false;

    protected init(): void {
        this.subscription.add(this.store.isSummary().subscribe((isSummary) => (this.isSummary = isSummary)));

        this.subscription.add(
            this.getHasCoApplicant().subscribe((hasCoApplicant) => {
                this.hasCoApplicant = hasCoApplicant;
                this.activeQuestionSubject.next(0);
            })
        );
    }

    getHasCoApplicant(): Observable<boolean> {
        return this.store.getHasCoApplicant();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    update(): void {
        throw new Error('Method not implemented.');
    }

    getInitialValues() {
        throw new Error('Method not implemented.');
    }

    getActiveQuestion(): Observable<number> {
        return this.activeQuestionSubject.asObservable();
    }

    nextQuestion(next = 1): void {
        if (!this.isSummary) {
            const nextQuestion = this.activeQuestionSubject.value + next;
            if (nextQuestion === this.lastQuestion) {
                this.store.nextOption();
            } else if (this.isActiveQuestion(nextQuestion as Q)) {
                this.activeQuestionSubject.next(nextQuestion as Q);
            } else {
                this.nextQuestion(next + 1);
            }
        }
    }

    backQuestion(back = 1): void {
        if (!this.isSummary) {
            const nextQuestion = this.activeQuestionSubject.value - back;
            if (nextQuestion === -1) {
                this.store.backOption();
            } else if (this.isActiveQuestion(nextQuestion as Q)) {
                this.activeQuestionSubject.next(nextQuestion as Q);
            } else {
                this.backQuestion(back + 1);
            }
        }
    }

    isActiveQuestion(question: Q): boolean {
        return question !== this.lastQuestion;
    }
}
